var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17 10L12 14.6138L7 10L17 10Z","fill":"#00121A","key":0}),React.createElement("mask",{"id":"mask0","maskType":"alpha","maskUnits":"userSpaceOnUse","x":"7","y":"10","width":"10","height":"5","key":1},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17 10L12 14.6138L7 10L17 10Z","fill":"white"})),React.createElement("g",{"mask":"url(#mask0)","key":2})]);
}

ArrowDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
